import * as React from 'react';
import { CartService } from '../../Cart/types';
import { ServiceSummary } from '../../features/service-summary';
const InsuranceSummary = props => {
    var _a;
    const selectedInsurancesCodes = new Set((_a = props.selectedInsurances) === null || _a === void 0 ? void 0 : _a.map(insurance => { var _a; return (_a = insurance.insuranceProgram) === null || _a === void 0 ? void 0 : _a.code; }));
    return (React.createElement(ServiceSummary, { serviceType: "Insurance", mode: props.mode, renderSummary: groups => {
            const items = groups.reduce((items, group) => [
                ...items,
                ...group.items
                    .filter(item => selectedInsurancesCodes.has(item.id))
                    .map(item => (Object.assign(Object.assign({}, item), { included: !props.onServiceDelete || item.included, downloadUrl: props.isDownload ? item.downloadUrl : null, onDelete: props.onServiceDelete && item.deleteMeta
                        ? () => props.onServiceDelete(CartService.Insurances, item.deleteMeta)
                        : null })))
            ], []);
            return props.children(items);
        } }));
};
export default InsuranceSummary;
